import { ToastrService } from 'ngx-toastr';
import { ISetting } from './../../../_models/cms/ISetting';
import { SettingService } from './../../../shared/services/setting.service';
import { IPaged } from './../../../_models/common/IPaged';
import { CommonService } from './../../../shared/services/common.service';
import { VacantPostService } from './../../../shared/services/vacant-post.service';
import { Router, ActivatedRoute } from '@angular/router';
import { IKeyValuePair } from './../../../_models/common/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  loading: boolean = true;
  private readonly PAGE_SIZE = 10;
  regions: IKeyValuePair[];
  states: IKeyValuePair[];
  districts: IKeyValuePair[];
  schools: IKeyValuePair[];
  designations: IKeyValuePair[];

  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'UpdatedAt',
    sortDir: 'Descending',
    designationId: '',
    regionId: '',
    stateId: '',
    districtId: '',
    schoolId: ''
  };

  columns = [
    { title: 'Sr.No.', key: 'Id', isSortable: true },
    { title: 'School', key: 'SchoolId', isSortable: true },
    { title: 'Designation', key: 'DesignationId', isSortable: true },
    { title: 'Type', key: 'VacancyTypeId', isSortable: true },
    { title: 'No Of Post', key: 'NoOfPost', isSortable: true }
  ];

  setting: ISetting;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private service: VacantPostService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private settingService: SettingService) {




  }

  async ngOnInit() {

    this.setting = await this.settingService.getSetting();
    if (!this.setting.isVacancyEmp) {
      this.toastrService.warning("vacancy module closed!");
      this.router.navigate(['/']);
      return;
    }

    this.bindDropDown();
    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort;
        this.query.sortDir = params.sortDir;
        this.query.designationId = params.designationId ? params.designationId : '';
        this.query.regionId = params.regionId ? params.regionId : '';
        this.query.stateId = params.stateId ? params.stateId : '';
        this.query.districtId = params.districtId ? params.districtId : '';
        this.query.schoolId = params.schoolId ? params.schoolId : '';
        this.populateVacantPosts();
        this.bindCascadeDropDown();
      });
  }

  bindDropDown() {
    this.commonService.getRegions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.regions = response;
      }
    });
    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.designations = response;
      }
    });

  }

  bindCascadeDropDown() {
    if (this.query.regionId) {
      this.getStates(this.query.regionId);
    }
    if (this.query.stateId) {
      this.getDistricts(this.query.stateId);
    }
    if (this.query.districtId) {
      this.getSchools(this.query.districtId);
    }
  }

  private populateVacantPosts() {
    this.loading = true;
    this.service.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      }, (err) => console.log(err),
        () => this.loading = false);
  }

  getStates(regionId: string) {
    this.commonService.getStates(regionId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });
  }

  getDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.districts = response;
      }
    });
  }

  getSchools(districtId: number) {
    this.commonService.getSchools(districtId, 1).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schools = response;
      }
    });
  }

  filter() {
    this.query.page = 1;
    this.router.navigate(['/vacancy'], {
      queryParams: this.query
    });
  }

  sortBy(columnName) {
    this.query.page = 1;
    if (this.query.sort === columnName) {
      this.query.sortDir = (this.query.sortDir == "Descending" ? "Ascending" : "Descending");
    } else {
      this.query.sort = columnName;
      this.query.sortDir = "Descending";
    }

    this.router.navigate(['/vacancy'], {
      queryParams: this.query
    });
  }

}
